import React from "react";
import App from "../../../pages/report/multiSelect";
import Field from "../../Common/Field/Field";
import Async from "react-select";
const FabricForm = props => {

  return (
    <div class="col-md-12 mx-auto br-col p-1">
      <div className="col-md-12 p-2">
        <div className="col-md-6">
          <label>Customer department</label>
        </div>
        <div className="col-md-6" style={{ zIndex: 1000 }}>
          <App
            customerInfo={props.customerWithDepartment}
            selectedCustomers={props.storeCustomerData}
          />
        </div>
      </div>
      <div className="col-md-12 p-1">
        <div className="col-md-6">
          <label>supplier</label>
        </div>
        <div className="col-md-6">
          <div class="custom-async-select height-adjust">
            <Async
              name="supplierName"
              value={props.supplierName}
              // onInputChange={this.getSupplierInfo}
              onChange={props.changeSupplierInfo}
              placeholder="Find Suppliername"
              options={props.supplierOption}
              disabled={false}
            />
          </div>
        </div>
      </div>
      <div className="col-md-12 p-1">
        <div className="col-md-6">
          <label>Requirement</label>
        </div>
        <div className="col-md-6 height-adjust">
          <Field
            inputType="select"
            inputName="requirement"
            value={props.requirement}
            options={props.requirementOption}
            onChange={props.updateState}
            disabled={false}
            className="Select-control"
          />
        </div>
      </div>
      <div className="col-md-12 p-1">
        <div className="col-md-6">
          <label>Status</label>
        </div>
        <div className="col-md-6 height-adjust">
          <Field
            inputType="select"
            inputName="status"
            value={props.status}
            options={props.statusOptions.filter(x => x.value !== "IN PROCESS")}
            onChange={props.updateState}
            disabled={false}
            className="Select-control"
          />
        </div>
      </div>
    </div>
  );
};

export default FabricForm;


// WEBPACK FOOTER //
// ./src/components/Report/forms/FabricForm.js